if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /* Corvex atc-vitals-bypass 2026-06-05:
         App Vitals/Videowise registra listener capture-phase no botao Add to cart e da preventDefault().
         Resultado: o submit do form nunca dispara, /cart/add nao e chamado, AddToCart nao sai.
         Solucao: registrar nosso proprio click handler em capture-phase ANTES do Vitals e fazer
         POST direto /cart/add.js via fetch. NAO removemos o submit handler — guard com flag
         _corvexAtcInFlight previne double-add caso o submit nativo volte a rodar.
      */
      connectedCallback() {
        if (this._corvexBound) return;
        this._corvexBound = true;
        try {
          this._corvexClickHandler = this.corvexAtcClickHandler.bind(this);
          /* Capture-phase + listener no DOCUMENT garante que rodamos ANTES do Vitals */
          document.addEventListener('click', this._corvexClickHandler, true);
        } catch (e) { /* noop */ }
        /* Corvex v3 05/06: ViewContent via dataLayer evento 'Product' (o GTM alimenta Pixel+CAPI+TikTok+GAds) */
        try { this.corvexFireViewContent(); } catch (e) { /* noop */ }
      }

      disconnectedCallback() {
        try {
          if (this._corvexClickHandler) {
            document.removeEventListener('click', this._corvexClickHandler, true);
          }
        } catch (e) { /* noop */ }
      }

      /* === Corvex v3: tracking via dataLayer no formato exato que o GTM da Brilia espera ===
         Eventos: 'Product' (ViewContent) e 'Add to Cart' (AddToCart), cada um com array `products`
         no shape {id,name,price,brand,categories,quantity}. price em dolares string "39.00".
         O GTM dispara Pixel browser + CAPI server + TikTok + Google Ads a partir disso. */
      corvexMoney(cents) {
        var n = Number(cents);
        if (isNaN(n)) return undefined;
        return (n / 100).toFixed(2);
      }

      corvexPushProductsEvent(eventName, products) {
        try {
          if (!products || !products.length) return;
          var now = Date.now();
          /* Dedupe AddToCart: nunca conta dobrado entre o bypass e o submit nativo */
          if (eventName === 'Add to Cart') {
            if (window._corvexLastAtcPush && (now - window._corvexLastAtcPush) < 2000) return;
            window._corvexLastAtcPush = now;
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: eventName, products: products });
        } catch (e) { /* noop */ }
      }

      /* Monta products a partir da resposta do /cart/add.js (AddToCart) */
      corvexProductsFromCartResp(resp) {
        var self = this;
        var src = (resp && resp.items && resp.items.length) ? resp.items : (resp && (resp.id || resp.variant_id) ? [resp] : []);
        return src.map(function(it){
          return {
            id: String(it.product_id || it.id || ''),
            name: it.product_title || it.title || '',
            price: self.corvexMoney(it.price) || '0.00',
            brand: it.vendor || '',
            categories: ['', it.product_type || ''],
            quantity: it.quantity || 1
          };
        });
      }

      /* ViewContent: empurra 'Product' uma vez por pageview, so em PDP. connectedCallback roda cedo,
         entao poll curto ate ShopifyAnalytics.meta.product estar pronto. */
      corvexFireViewContent() {
        if (window._corvexVCFired || window._corvexVCScheduled) return;
        window._corvexVCScheduled = true;
        var self = this;
        var attempts = 0;
        var timer = setInterval(function () {
          attempts++;
          var prod = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || null;
          if (prod && prod.id && Array.isArray(window.dataLayer)) {
            clearInterval(timer);
            if (window._corvexVCFired) return;
            window._corvexVCFired = true;
            try {
              var selVariantId = null;
              try { var fd = self.form ? new FormData(self.form) : null; selVariantId = fd ? fd.get('id') : null; } catch (e) {}
              var variants = prod.variants || [];
              var v = null;
              if (selVariantId) { for (var i=0;i<variants.length;i++){ if (String(variants[i].id)===String(selVariantId)){ v=variants[i]; break; } } }
              if (!v) v = variants[0] || null;
              var products = [{
                id: String(prod.id),
                name: (v && v.name) || prod.handle || '',
                price: self.corvexMoney(v ? v.price : 0) || '0.00',
                brand: prod.vendor || '',
                categories: ['', prod.type || ''],
                quantity: 1
              }];
              self.corvexPushProductsEvent('Product', products);
            } catch (e) { /* noop */ }
          } else if (attempts >= 40) {
            clearInterval(timer); /* ~12s sem produto: provavelmente nao e PDP */
          }
        }, 300);
      }

      corvexAtcClickHandler(evt) {
        try {
          var target = evt.target;
          if (!target || !target.closest) return;
          /* So intercepta cliques dentro DESTE product-form */
          var btn = target.closest('button[type="submit"], button[name="add"]');
          if (!btn) return;
          if (!this.contains(btn)) return;
          if (btn.getAttribute('aria-disabled') === 'true') return;
          /* Sold out / desabilitado */
          if (btn.disabled) return;
          /* Re-entrancia guard */
          if (this._corvexAtcInFlight) return;
          this._corvexAtcInFlight = true;

          /* Coleta payload do form */
          var form = this.form;
          if (!form) { this._corvexAtcInFlight = false; return; }
          var fd = new FormData(form);
          var variantId = fd.get('id');
          var qty = parseInt(fd.get('quantity') || '1', 10);
          if (!variantId) { this._corvexAtcInFlight = false; return; }

          /* Loading UI */
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('loading');
          var spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          var self = this;
          /* POST /cart/add.js — funciona MESMO se Vitals der preventDefault no click,
             porque ja interceptamos em capture antes do Vitals e nao dependemos do submit. */
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: variantId, quantity: qty })
          })
          .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, status: r.status, body: j }; }); })
          .then(function(res){
            if (!res.ok || (res.body && res.body.status)) {
              /* Erro: deixa o fluxo nativo tentar (remove guard) */
              self._corvexAtcInFlight = false;
              try { self.handleErrorMessage(res.body && res.body.description ? res.body.description : (res.body && res.body.message) || 'Add to cart failed'); } catch(e){}
              return;
            }
            var resp = res.body;
            /* Corvex v3: empurra 'Add to Cart' no formato do GTM (Pixel+CAPI+TikTok+GAds via dataLayer) */
            try {
              self.corvexPushProductsEvent('Add to Cart', self.corvexProductsFromCartResp(resp));
            } catch (e) { /* noop tracking */ }

            /* Atualiza/abre cart drawer */
            try {
              self.ensureCartUpgraded();
              if (self.cart && typeof self.cart.renderContents === 'function') {
                /* renderContents espera o response do /cart/add com sections; como nao pedimos sections,
                   forcamos uma renderizacao via fetch das sections do cart-drawer */
                self.corvexRefreshDrawer().then(function(){
                  if (self.cart && typeof self.cart.open === 'function') {
                    try { self.cart.open(); } catch(e){}
                  }
                });
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'corvex-atc-bypass',
                  productVariantId: variantId,
                  cartData: resp,
                });
              }
            } catch (e) { /* noop drawer */ }
          })
          .catch(function(err){
            self._corvexAtcInFlight = false;
          })
          .finally(function(){
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
            /* Mantem guard ate o submit nativo expirar (caso Vitals nao bloqueie, queremos no-op no submit) */
            setTimeout(function(){ self._corvexAtcInFlight = false; }, 1500);
          });

          /* NAO chamamos preventDefault aqui — deixamos o submit nativo rodar.
             Se ele rodar tambem, nosso guard _corvexAtcInFlight faz com que o segundo POST seja no-op
             porque o onSubmitHandler ja checa aria-disabled (que setamos). */
        } catch (e) { this._corvexAtcInFlight = false; }
      }

      corvexRefreshDrawer() {
        /* Fetch cart-drawer sections e re-renderiza */
        try {
          var self = this;
          var sections = self.cart && typeof self.cart.getSectionsToRender === 'function'
            ? self.cart.getSectionsToRender().map(function(s){ return s.id; }).join(',')
            : null;
          if (!sections) return Promise.resolve();
          return fetch('/?sections=' + encodeURIComponent(sections))
            .then(function(r){ return r.json(); })
            .then(function(secData){
              try {
                self.cart.renderContents({ sections: secData, item_count: undefined });
              } catch (e) { /* noop */ }
            })
            .catch(function(){ /* noop */ });
        } catch (e) { return Promise.resolve(); }
      }


      /* Corvex atc-fix: garante que this.cart seja um custom element "upgraded" antes de uso.
         Sem isso, cart-drawer.js (carregado via corvex-ui-deferred) pode ainda nao ter definido
         a classe quando usuario clica ATC rapido, causando TypeError em getSectionsToRender. */
      ensureCartUpgraded() {
        if (!this.cart) return false;
        if (typeof this.cart.getSectionsToRender === 'function') return true;
        try {
          if (window.customElements && typeof window.customElements.upgrade === 'function') {
            window.customElements.upgrade(this.cart);
          }
        } catch (e) { /* noop */ }
        if (typeof this.cart.getSectionsToRender === 'function') return true;
        /* Custom element ainda nao definido. Limpa this.cart para acionar fallback de redirect. */
        this.cart = null;
        return false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.ensureCartUpgraded();
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

          this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }
        
                fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } 

            /* Corvex v3: se o submit nativo rodar (Vitals ausente), empurra 'Add to Cart' deduplicado */
            try {
              if (response && !response.status) {
                this.corvexPushProductsEvent('Add to Cart', this.corvexProductsFromCartResp(response));
              }
            } catch (e) { /* noop */ }

            if (this.skipCart) {
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.ensureCartUpgraded()) {
                      this.cart.renderContents(response);
                    } else {
                      window.location = window.routes.cart_url;
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.ensureCartUpgraded()) {
                this.cart.renderContents(response);
              } else {
                window.location = window.routes.cart_url;
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
            getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

